import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ElementUI from "element-ui";
import "@/components";
import "@/styles";
import VuevideoPlayer from "vue-video-player";

import "video.js/dist/video-js.css";

Vue.use(VuevideoPlayer);

Vue.config.productionTip = false;

Vue.use(ElementUI);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
